import { Activity, TrendingDown, TriangleAlert } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { PageHeader } from '@/app/shell/PageHeader'
import { ALERTS } from '@/mocks'
import { tok } from '@/charts'
import { Card } from '@/ui/card'
import { Chip } from '@/ui/chip'

const KIND_ICON: Record<string, LucideIcon> = { scada: Activity, drift: TrendingDown, obligation: TriangleAlert }
const SEV_TONE: Record<string, string> = { critical: tok('--ignition'), warning: tok('--flare'), info: tok('--clear') }
const age = (m: number) => (m < 60 ? `${m}m` : `${Math.round(m / 60)}h`)

export function AlertsPage() {
  return (
    <>
      <PageHeader
        title="Alerts"
        subtitle={
          <>
            <span>{ALERTS.length} unread</span>
            <Chip>simulated</Chip>
          </>
        }
      />
      <Card className="overflow-hidden p-0">
        {ALERTS.map((a) => {
          const Icon = KIND_ICON[a.kind] ?? TriangleAlert
          return (
            <div key={a.id} className="flex items-start gap-3 border-b p-4 last:border-b-0">
              <Icon className="mt-0.5 size-4 shrink-0" style={{ color: SEV_TONE[a.severity] }} />
              <div className="flex-1">
                <div className="text-[13.5px] font-medium">{a.message}</div>
                <div className="mt-0.5 text-[12px] text-faint">
                  {a.site} · {a.kind}
                </div>
              </div>
              <span className="text-[11.5px] text-faint">{age(a.ageMins)}</span>
            </div>
          )
        })}
      </Card>
      <p className="mt-3 text-[11.5px] text-faint">
        Cross-site alert inbox — simulated. Wires to SCADA thresholds, drift and obligations in the live feed.
      </p>
    </>
  )
}
